import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DialogHeader from './DialogHeader';

const DialogConfirm = ({
    onCancel,
    onClose,
    onSubmit,
    titleKey,
    cancelKey = 'actions.cancel',
    submitKey = 'actions.confirm',
    contentKey,
    children,
}) => {
    const { t } = useTranslation();

    const handleClose = () => {
        if (onCancel) onCancel();
        onClose();
    };

    const handleSubmit = () => {
        if (onSubmit) onSubmit();
        onClose();
    };

    return (
        <Dialog id="dlg-confirm" open onClose={handleClose}>
            <DialogHeader titleKey={titleKey} onClose={handleClose} />
            <DialogContent>
                {children ?? t(contentKey)}
            </DialogContent>
            <DialogActions>
                <Button id="btn-cancel-dlg-confirm" variant="outlined" onClick={handleClose}>
                    {t(cancelKey)}
                </Button>
                <Button id="btn-submit-dlg-confirm" onClick={handleSubmit}>
                    {t(submitKey)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogConfirm;
